import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import columnClasses from '../columns.css';

const SelectBox = ({
  focus,
  active,
  row,
  transactionsList,
  selectTransaction,
  deselectTransaction,
  selectedTransactions,
  disabled
}) => {
  const chkInput = useRef(null);

  const checkBoxClick = (e) => {
    const isSelected = e.target.checked;
    isSelected ? selectTransaction(row) : deselectTransaction(row);
  };

  useEffect(
    () => {
      if (chkInput.current) {
        if (active) chkInput.current.focus();
        else chkInput.current.blur();
      }
    },
    [active, chkInput]
  );

  return (
    <Checkbox
      name={row.BankDataGUID}
      checked={selectedTransactions.some(transaction => transaction.BankDataGUID === row.BankDataGUID)}
      onClick={checkBoxClick}
      color="default"
      className={columnClasses.SpreadsheetGrid__cell}
      disabled={disabled}
    />
  );
};

function mapStateToProps(state) {
    return {
        selectedTransactions: state.transactions.selectedTransactions,
    };
}

export default connect(mapStateToProps)(SelectBox);


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/SelectBox/selectBox.js